import { isPlatformServer } from '@angular/common';
import { Injectable } from '@angular/core';
import { UrlObject } from '../../models/utils/object.interfaces';
import { UrlUtilExtended } from './urlUtilExtended';

@Injectable({
  providedIn: 'root'
})
export class UrlUtil extends UrlUtilExtended {
  private _baseUrl!: string;
  /**
   * returns the HOST URL prefixed with the APP WEB CONTEXT
   * e.g. localhost:9000/app
   */
  get baseUrl() {
    return `${this.hostUrl}/${this.config.get('APP_CONTEXT_ROOT')}`;
  }

  private _basePort!: string | undefined;

  get basePort() {
    return this._basePort;
  }

  private _aemUrl!: string;

  get aemUrl() {
    return this._aemUrl;
  }

  private _utilUrl!: string;

  get utilUrl() {
    return this._utilUrl;
  }

  private _predictiveUrl!: string;

  get predictiveUrl() {
    return this._predictiveUrl;
  }

  private _profileUrl!: string;

  get profileUrl() {
    return this._profileUrl;
  }

  get custUrl() {
    return this._customerUrl;
  }

  /**
   * TODO - use require('query-string') package for conversion
   * @param obj - JSON object to be converted to URL params
   */
  toObjQueryString(obj: UrlObject) {
    return Object.keys(obj).reduce(function (str, key, i) {
      const delimiter = i === 0 ? '' : '&';
      key = encodeURIComponent(key);
      const val = encodeURIComponent(obj[key]);
      return [str, delimiter, key, '=', val].join('');
    }, '');
  }

  getURLParam(parameter: string, defaultvalue: undefined): string | undefined {
    const parameterList = window.location.search.substring(1);
    const keyValueList = parameterList.split('&');
    for (let i = 0; i < keyValueList.length; i++) {
      const keyValueSet = keyValueList[i].split('=');
      if (keyValueSet[0] === parameter) {
        return keyValueSet[1];
      }
    }
    return defaultvalue;
  }

  checkEnvironment() {
    const environment = this.injector.get('ENVIRONMENT_TOKEN');
    const profileJvm = environment.PROFILE_JVM;
    const predictiveJvm = environment.PREDICTIVE_JVM;
    const webserverHostname = environment.WEBSERVER_HOSTNAME;
    const customerJvm = environment.CUSTOMER_JVM;
    const UtilJvm = environment.UTIL_JVM;
    const isLocal = environment === 'local' ? true : false;
    return {
      profileJvm: profileJvm,
      predictiveJvm: predictiveJvm,
      webserverHostname: webserverHostname,
      customerJvm: customerJvm,
      UtilJvm: UtilJvm,
      isLocal: isLocal
    };
  }

  private _computeBaseUrl() {
    if (isPlatformServer(this.platformId)) {
      const _requestObject = this.injector.get('REQUEST_TOKEN');
      this._requestHost = _requestObject.headers.host;
      this._requestProtocol = _requestObject.protocol;
      this._hostname = _requestObject.hostname;
      const environment = this.checkEnvironment();
      const hostname = this.getHostName(environment);
      this._hostUrl = `${this._requestProtocol}://${hostname}`;
      this._baseUrl = `${this._hostUrl}/${this.config.get('APP_CONTEXT_ROOT')}`;
      this._basePort = this.getBase();

      this._aemUrl = this.getAEM(environment);
      this._customerUrl = this.getCustomerUrl(environment);
      this._utilUrl = this.getUtilUrl(environment);
      this._profileUrl = environment.isLocal
        ? this._hostUrl
        : `${this._requestProtocol}://${environment.profileJvm}`;
      this._predictiveUrl = environment.isLocal
        ? this._hostUrl
        : `${this._requestProtocol}://${environment.predictiveJvm}`;
    } else {
      const _protoUrl = `${this.winRef.getProtocol()}//`;
      this._hostUrl = `${_protoUrl}${this.winRef.getHost()}`;
      this._baseUrl = `${this._hostUrl}/${this.config.get('APP_CONTEXT_ROOT')}`;
      this._basePort = this.winRef.getPort();
      this._aemUrl = this._hostUrl;
      // this._aemUrl =  this.winRef.getOrigin().indexOf('local') > 1 ? this._hostUrl : `${this.winRef.getProtocol()}//${this.config.get('APP_AEM_HOST')}`;
      this._customerUrl = this._hostUrl;
      this._utilUrl = this._hostUrl;
      this._profileUrl = this._hostUrl;
      this._predictiveUrl = this._hostUrl;
    }
  }
}
